import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
function SizeLabel({ width, height }) {
    const w = Math.max(0, Math.round(width));
    const h = Math.max(0, Math.round(height));
    return (_jsxs("div", { className: "drawing-size-label", "aria-hidden": true, children: [w, " \u00D7 ", h] }));
}
export function DrawingPreview({ state, fillColor, strokeColor, strokeWidth, strokeStyle, }) {
    if (!state.isDrawing || !state.tool)
        return null;
    if (state.tool === 'curve') {
        const x0 = state.startX;
        const y0 = state.startY;
        const x2 = state.currentX;
        const y2 = state.currentY;
        const cx = state.controlX ?? (x0 + x2) / 2;
        const cy = state.controlY ?? (y0 + y2) / 2;
        const minX = Math.min(x0, cx, x2);
        const minY = Math.min(y0, cy, y2);
        const width = Math.max(10, Math.max(x0, cx, x2) - minX);
        const height = Math.max(10, Math.max(y0, cy, y2) - minY);
        const pathData = `M ${x0 - minX} ${y0 - minY} Q ${cx - minX} ${cy - minY} ${x2 - minX} ${y2 - minY}`;
        return (_jsxs("div", { className: "drawing-preview", style: { left: minX, top: minY, width, height }, children: [_jsx("svg", { width: width, height: height, style: { display: 'block', overflow: 'visible' }, children: _jsx("path", { d: pathData, fill: "none", stroke: strokeColor, strokeWidth: strokeWidth, strokeDasharray: strokeStyle === 'dashed' ? '8,4' : strokeStyle === 'dotted' ? '2,2' : undefined }) }), _jsx(SizeLabel, { width: width, height: height })] }));
    }
    const x = Math.min(state.startX, state.currentX);
    const y = Math.min(state.startY, state.currentY);
    const width = Math.abs(state.currentX - state.startX);
    const height = Math.abs(state.currentY - state.startY);
    const shapeStyle = {
        width: '100%',
        height: '100%',
        boxSizing: 'border-box',
        border: `2px dashed ${strokeColor}`,
        background: `${fillColor}40`,
    };
    let shape;
    if (state.tool === 'circle') {
        shape = _jsx("div", { style: { ...shapeStyle, borderRadius: '50%' } });
    }
    else if (state.tool === 'triangle') {
        shape = (_jsx("svg", { width: "100%", height: "100%", viewBox: `0 0 ${Math.max(width, 1)} ${Math.max(height, 1)}`, preserveAspectRatio: "none", style: { display: 'block' }, children: _jsx("polygon", { points: `${width / 2},0 0,${height} ${width},${height}`, fill: `${fillColor}40`, stroke: strokeColor, strokeWidth: 2, strokeDasharray: "8,4" }) }));
    }
    else {
        shape = _jsx("div", { style: shapeStyle });
    }
    return (_jsxs("div", { className: "drawing-preview", style: { left: x, top: y, width, height }, children: [shape, _jsx(SizeLabel, { width: width, height: height })] }));
}
